import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';

const DynamicThemeSpecial = dynamic(() => import('./theme-special'), {
  ssr: false,
  loading: Skeleton
});

const ThemeSpecial = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicThemeSpecial skeleton={skeleton} {...props} />;
};

export default ThemeSpecial;
